import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Box,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Icon,
  Select,
  Stack,
} from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MaterialTypography from "../../components/MaterialTypography";
import { BsFillPersonBadgeFill, BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../components/MasterSelect";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import "./quation.css";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import BASEURL from "../Utils/Baseurl";
import request, { gql } from "graphql-request";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {
  allContact,
  AllOpportunityByMasterQuery,
  AllOpportunityByUserQuery,
  AllOpportunityQuery,
  AllOpportunityTypeQuery,
  getContactdetail,
  QuotationOpportunityQuery,
  getContactdetailByMaster,
  getCustomerdetailByUser,
  getOpportunityTypeByMasterOptions,
  getOpportunityTypeByUserOptions,
  getQuotationByContactOrganizationId,
} from "../../lib/graphQL/graphQuery";
import {
  addQuationFieldService,
  delteQuationService,
  updateQuationService,
} from "../../lib/appUtliz/QuationsService";
import ReactQuill from "react-quill";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteQuotation } from "../../lib/graphQL/graphMutation";
import { useOppurtunityId } from "../opportunity/OppurtunityContext";
import { getQuotationDetail, getQuotationProductsDetail } from "./quationQuery";
import PercentIcon from "@mui/icons-material/Percent";
import { useCustomer } from "../../context/apiContext/CustomerContext";
import { useLeadAndProscpect } from "../../context/apiContext/Lead-and-ProspectContext";
import { useLoading } from "../../context/LodingContext";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";
import { fromGlobalId } from "../../lib/decoded/rawPk";
import "react-quill/dist/quill.snow.css";
import { isNull } from "lodash";  
import { use } from "react";
const getUserDetailByMaster = gql`
  query {
    salesRolesManager {
      id
      username
    }
  }
`;
const allProduct = gql`
  query alldetail {
    allProduct {
      id
      user {
        id
        username
        email
      }
      productName
      category {
        id
        categoryName
      }
      HSNNumber
      productCost
      sellingPrice
      SKU
      UOM {
        id
        uomName
      }
      reorderLevel
      location {
        id
        warehouseName
      }
      Tax
      productImage
      description
      lastUpdate
    }
  }
`;
const allUsersDetail = gql`
  query {
    allUsersDetail {
      id
      username
    }
  }
`;
const getContactdetailByUser = gql`
  query getContactByUser($id: String!) {
    getContactdetailByUser(id: $id) {
      id
      firstName
      mailId
      contactNumber
      organizationType
      organizationId
    }
  }
`;
const today = new Date().toISOString().split("T")[0];

const QuationsForm = () => {
  const [selectedData, setSelectedData] = useState([]);
  const location = useLocation();

  const [quationProductField, setQuationProductField] = useState([
    {
      id: "",
      productName: "",
      description: "",
      quantity: "",
      rate: "",
      discount: "",
      discountAmount: "",
      marginAmount: "",
      tax: 0,
      margin: "",
      amount: "",
      taxAmount: "",
      totalproductamount: "",

      HSN: "",
      SKU: "",
      comments: "",

      commentsStatus: "unchecked",
      productNameStatus: "unchecked",
      descriptionStatus: "unchecked",
      quantityStatus: "unchecked",
      rateStatus: "unchecked",
      discountStatus: "unchecked",
      discountAmountStatus: "unchecked",
      marginAmountStatus: "unchecked",
      taxStatus: 0,
      marginStatus: "unchecked",
      amountStatus: "unchecked",
      taxAmountStatus: "unchecked",
      totalproductamountStatus: "unchecked",
      HSNStatus: "unchecked",
      SKUStatus: "unchecked",
    },
  ]);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [quationFieldData, setQuationFieldData] = useState({
    opportunityID: "",
    customer: "",
    billingAddress: "",
    shippingAddress: "",
    contactPerson: "",
    quoteDate: today,
    discount: "",
    discountAmount: "",
    totalAmount: "",
    dueDate: "",
    accountingManager: "",
    terms: "",
    additionalInfo: "",
    features: "",
    subTotal: 0,
    totalTax: 0,
    amountAndTax: 0,
    bussinesPartner: "",
    otherCharges: "",
    otherChargesAmount: "",
    preferredBy: "",
    productDiscountPercentage: 0,
    // products: quationProductField,
    preferredByStatus: "unchecked",

    opportunityIDStatus: "unchecked",
    bussinesPartnerStatus: "unchecked",
    customerStatus: "unchecked",
    billingAddressStatus: "unchecked",
    shippingAddressStatus: "unchecked",
    contactPersonStatus: "unchecked",
    quoteDateStatus: "success",
    discountStatus: "unchecked",
    discountAmountStatus: "unchecked",
    totalAmountStatus: "unchecked",
    dueDateStatus: "unchecked",
    accountingManagerStatus: "unchecked",
    termsStatus: "unchecked",
    additionalInfoStatus: "unchecked",
    subTotalStatus: "unchecked",
    totalTaxStatus: "unchecked",
    amountAndTaxStatus: "unchecked",
    otherChargesStatus: "unchecked",
    otherChargesAmountStatus: "unchecked",
  });



  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [opportunityIdOptions, setOpportunityIdOptions] = useState([]);
  const [customerOption, setCustomerOption] = useState([]);
  const [termsError, setTermsError] = useState(false);
  const [singleCustomerData, setSingleCustomerData] = useState([]);
  const [singleDataStatus, setSingleDataStatus] = useState(false);
  const [billingAddressOption, setBillingAddressOption] = useState([]);
  const [managerDataOption, setManagerDataOption] = useState([]);
  const [productData, setProductData] = useState([]);
  const [productIndex, setProductIndex] = useState(0);
  const addbuttonref = useRef(null);
  const { currentUser } = useAuth();
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } =
    useError();
  const { setIdValue, idValue } = useOppurtunityId();
  const [disbledStatus, setDisbledStatus] = useState(true);
  const [contactDropDown, setContactDropDown] = useState([]);
  const isUser = currentUser?.role;
  const bussinessPartnerOptions = ["Customer", "Prospect"];
  const navigate = useNavigate();
  const [editStatus, setEditStatus] = useState(false);
  const [editStatustrue, setEditstatustrue] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);
  const [ConvertToQuoteStatus, setConvertToQuoteStatus] = useState(false);
  const { customerData, setCustomerData, fetchCustomerData } = useCustomer();
  const { leadData, setLeadData, fetchLeaddata } = useLeadAndProscpect();
  const [editdisablebutton, seteditdisablebutton] = useState(true);
  const params = useLocation();
  const [discountShowStatus, setDiscountShowStatus] = useState(false);
  const [discountShowButton, setDiscountShowButton] = useState(false);
  const { id: rawPk } = fromGlobalId(currentUser?.id);
  const id1 = params.search.slice(1);
  const [open, setOpen] = React.useState(false);
  const [showOtherCharges, setShowOtherCharges] = useState(false);
  
  
  
  const handleToggleOtherCharges = () => {
    
    setShowOtherCharges((prev) => !prev);
    if (!showOtherCharges) {
      setQuationFieldData((prev) => ({
        ...prev,
        otherCharges: "",
        otherChargesAmount: "",
        otherChargesStatus:"unchecked",
        otherChargesAmountStatus:"unchecked",
      }));
    }
  };
  
  
  var type = null;
  const [allEmployee, setAllEmployee] = useState([]);

  useEffect(() => {
    if (quationFieldData.otherCharges || quationFieldData.otherChargesAmount) {
      setShowOtherCharges(true);
    }
  }, [quationFieldData]);
  

  useEffect(() => {
    request(BASEURL, allUsersDetail).then((res) =>
      setAllEmployee(res.allUsersDetail)
    );
  }, []);

  const taxOption = [
    {
      id: 0,
      label: "0%",
    },
    {
      id: 5,
      label: "5%",
    },
    {
      id: 10,
      label: "10%",
    },
    {
      id: 12,
      label: "12%",
    },
    {
      id: 18,
      label: "18%",
    },
    {
      id: 28,
      label: "28%",
    },
  ];
  useEffect(() => {
    fetchCustomerData();
    fetchLeaddata();
  }, []);
  useEffect(() => {
    // if (id1) {
    //   seteditdisablebutton(false);
    //   fetchUpdateValue();
    // } else {
    //   seteditdisablebutton(true);
    // }
    if (id1) {
      fetchUpdateValue();
      seteditdisablebutton(false);
      if (params.pathname == "/quotation/view-quotation") {
        setEditstatustrue(true);
        setEnableEdit(false);
      } else {
        setEditstatustrue(false);
        setEnableEdit(false);
      }
      setDiscountShowStatus(true);
      setDiscountShowButton(false);
      setEditStatus(true);
    } else {
      seteditdisablebutton(true);
      setDiscountShowStatus(false);
      setDiscountShowButton(true);
      setEditStatus(false);
      setEditstatustrue(false);
      setEnableEdit(true);
    }
  }, [id1]);

  // const update = () => {
  //   let temp = { ...quationFieldData }

  //   temp = {
  //     opportunityID: {
  //       value: "1",
  //       label: "1"
  //     }
  //   }
  //   setQuationFieldData({
  //     temp
  //   });
  // }


  useEffect(() => {
    if (location?.state?.type === "convert") {
      setConvertToQuoteStatus(true);

      setQuationFieldData({

        opportunityID: location.state.opportunityID,
        customer: location.state.customer,
        opportunityFrom: location.state.opportunityFrom,
        contactPerson: location.state.contactPerson,
      });

    }
    else{
      setConvertToQuoteStatus(false);
    }
  }, [location?.state]); // Add dependency to ensure re-execution when location.state changes


  useEffect(() => {
    if (id1) {
      fetchUpdateValue();
    } else {
      console.error("id1 is undefined or null");
    }
  }, [id1]);


  type = "add";

  const fetchUpdateValue = async () => {
    if (type == "add") {
      
      setCirleLoading(true);
      try {
        const res = await request(BASEURL, getQuotationDetail, {
          id: id1,
        });
        
        const v = res.getQuotationDetail;

        setQuationFieldData((prev) => ({
          ...prev,
          opportunityID:
          {
            value: v.opportunity?.id || "",
            label: v.opportunity?.oppid || "",
          }
          ,
          customer: {
            value: v.customer,
            label: v.relatedName,
          },
          billingAddress: {
            value: v.billingAddress,
            label: v.billingAddress,
          },
          shippingAddress: {
            value: v.shippingAddress,
            label: v.shippingAddress,
          },

          preferredBy: {
            value: v.preferredBy?.id || "",

            label: v.preferredBy?.username || "",
          },
          bussinesPartner: {
            value: v.businessPartner,
            label: v.businessPartner,
          },
          contactPerson: {
            value: v.contactPerson,
            label: v.contactPerson,
          },
          quoteDate: v.quoteDate,
          discount: v.discountPercentage === "0.00"?"": v.discountPercentage,
          discountAmount: v.discount === "0.00"? "": v.discount,
          totalAmount: v.totalAmount,
          dueDate: v.dueDate,
          accountingManager: {
            value: v.accountingManager?.id,
            label: v.accountingManager?.username,
          },
          terms: v.termsAndConditions,
          additionalInfo: v.additionalInformations,
          features: v.features,

          // subTotal: v.
          // subTotal,
          subTotal: v?.subTotal,

          totalTax: v.totalTaxAmount,
          amountAndTax: v?.amountAndTax,

          otherCharges: v.otherCharges === "0.00" ? "" : v.otherChargesDescription,
          otherChargesAmount: v.otherCharges === "0.00" ? "" : v.otherCharges,
          products: quationProductField,

          opportunityIDStatus: v.opportunity?.id ? "success" : "unchecked",
          customerStatus: "success",
          billingAddressStatus: "success",
          shippingAddressStatus: "success",
          contactPersonStatus: "success",
          quoteDateStatus: "success",
          discountStatus: v.discount==="0.00" || v.discount === "0" ? "unchecked" : "success",
          discountAmountStatus: v.discount === "0.00" || v.discount === "0" ?"unchecked" : "success",
          totalAmountStatus: "success",
          dueDateStatus: "success",
          accountingManagerStatus: "success",
          termsStatus: "success",
          additionalInfoStatus: "success",
          subTotalStatus: "success",
          totalTaxStatus: "success",
          amountAndTaxStatus: "success",
          otherChargesStatus: v.otherCharges === "0.00" || v.otherCharges === "0" ? "unchecked" : "success",
          otherChargesAmountStatus: v.otherCharges === "0.00" || v.otherCharges === "0"  ? "unchecked" : "success",
          bussinesPartnerStatus: "success",
          preferredByStatus: "success",
        }));

        const response2 = await v.quotationproductsSet?.map((v, i) => {
          return {
            id: v.id,
            productName: {
              value: v?.productName?.id,
              label: v?.productName?.productName,
            },
            description: v.comments,
            quantity: v.quantity,
            rate: v.rate,
            discount: 0,
            discountAmount: 0,
            marginAmount: v.marginValue,
            tax: {
              value: v.tax,
              label: parseInt(v.tax) + "%",
            },
            margin: v.margin,
            amount: v.amount,
            taxAmount: v.taxAmount,
            totalproductamount: v.totalproductamount,
            HSN: v.HSNNumber,
            SKU: v.SKU,
            comments: v.comments,
            productDiscountPercentage: v.productDiscountPercentage || 0,

            commentsStatus: "success",
            productNameStatus: "success",
            descriptionStatus: "success",
            quantityStatus: "success",
            rateStatus: "success",
            discountStatus: "success",
            discountAmountStatus: "success",
            marginAmountStatus: "success",
            taxStatus: "success",
            marginStatus: "success",
            amountStatus: "success",
            taxAmountStatus: "success",
            totalproductamountStatus: "success",
            HSNStatus: "success",
            SKUStatus: "success",
          };
        });
        
        setQuationProductField(response2);
      } catch (err) {
      } finally {
        setCirleLoading(false);
      }
    }
  };


  useEffect(() => {
    fetchOpportunityId();
    // fetchCustomer();
    fetchAccountManger();
    fetchProduct();
  }, []);

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const fetchAccountManger = () => {
    request(BASEURL, getUserDetailByMaster, { id: currentUser?.id })
      .then((res) => {
        setManagerDataOption(res.salesRolesManager);
      })
      .catch((err) => console.error(err.message));
  };

  const fetchOpportunityId = () => {
    // request(
    //   BASEURL,
    //   isUser.toLowerCase() == "manager" ||
    //     isUser.toLowerCase() == "supervisor" ||
    //     isUser.toLowerCase() == "accounting manger"
    //     ? getOpportunityTypeByMasterOptions
    //     : isUser.toLowerCase() == "employee"
    //     ? getOpportunityTypeByUserOptions
    //     : isUser.toLowerCase() == "superuser"
    //     ? AllOpportunityTypeQuery
    //     : "Data Not Found",
    //   { id: currentUser?.id }
    // ).then((res) => {
    //   setOpportunityIdOptions(
    //     isUser.toLowerCase() == "manager"
    //       ? res.getOpportunitytypeByMaster
    //       : isUser.toLowerCase() == "employee"
    //       ? res.getOpportunitytypeByUser
    //       : isUser.toLowerCase() == "superuser"
    //       ? res.allOpportunitytype
    //       : []
    //   );
    // });
    if (location?.state?.type !== "convert") {

      request(
        BASEURL,
        isUser.toLowerCase() == "manager"
          ? AllOpportunityByMasterQuery
          : isUser.toLowerCase() == "employee"
            ? AllOpportunityByUserQuery
            : isUser.toLowerCase() == "superuser"
              ? QuotationOpportunityQuery
              : "Data Not Found",
        { id: currentUser?.id }
      ).then((res) => {
        setOpportunityIdOptions(
          isUser.toLowerCase() == "manager"
            ? res.getOpportunityByMaster
            : isUser.toLowerCase() == "employee"
              ? res.getOpportunityByUser
              : isUser.toLowerCase() == "superuser"
                ? res.allOpportunity
                : []
        );
      });
    }
  };
  // const fetchCustomer = () => {
  //   request(BASEURL, getCustomerdetailByUser, { id: currentUser?.id }).then(
  //     (res) => {
  //       setCustomerOption(res.getCustomerdetailByUser);
  //     }
  //   );
  // };

  const fetchProduct = () => {
    request(BASEURL, allProduct)
      .then((res) => {
        setProductData(res.allProduct);
      })
      .catch((err) => console.error(err.message));
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  

  const handleaddProductRow = () => {
    setOpen(true);
    const isAddrow = quationProductField.some(
      ({ productName }) => !productName
    );

    setQuationProductField([
      ...quationProductField,
      {
        productName: "",
        description: "",
        quantity: "",
        rate: "",
        discount: 0,
        discountAmount: "",
        marginAmount: "",
        tax: 0,
        margin: "",
        amount: "",
        taxAmount: "",
        totalproductamount: "",
        HSN: "",
        SKU: "",
        productDiscountPercentage: 0,

        productNameStatus: "unchecked",
        descriptionStatus: "unchecked",
        quantityStatus: "unchecked",
        rateStatus: "unchecked",
        discountStatus: 0,
        discountAmountStatus: 0,
        marginAmountStatus: "unchecked",
        taxStatus: 0,
        marginStatus: "unchecked",
        amountStatus: "unchecked",
        taxAmountStatus: "unchecked",
        totalproductamountStatus: "unchecked",
        HSNStatus: "unchecked",
        SKUStatus: "unchecked",
      },
    ]);
  };
  
  const handledelteProductRow = (ind) => {
    const newrow = quationProductField.filter((val, i) => i !== ind);
    setQuationProductField(newrow);
  };

  const [inputValue, setInputValue] = useState(""); // State to store input value
  const bullet = "\u2022";
  const bulletWithSpace = `${bullet} `;
  const enter = 13;

  const handleInput = (event) => {
    const { keyCode, target } = event;
    const { selectionStart, value } = target;

    if (keyCode === enter) {
      const updatedValue = [...value]
        .map((c, i) => (i === selectionStart - 1 ? `\n${bulletWithSpace}` : c))
        .join("");

      const normalizedValue = updatedValue.replace(/\n{2,}/g, "\n");

      setQuationFieldData({
        ...quationFieldData,
        terms: normalizedValue,
        termsStatus: "success",
      });

      setTimeout(() => {
        target.selectionStart = selectionStart + bulletWithSpace.length;
        target.selectionEnd = selectionStart + bulletWithSpace.length;
      }, 0);
    } else {
      const normalizedValue =
        value[0] !== bullet ? bulletWithSpace + value : value;

      const cleanedValue = normalizedValue.replace(/\n{2,}/g, "\n");

      setQuationFieldData({
        ...quationFieldData,
        terms: cleanedValue,
        termsStatus: "success",
      });
    }
  };
  
  const handleaddCharges = () => {
    
  }

  const handleQuationDataChange = (event, selectEvent) => {
    let quationFieldDataState = { ...quationFieldData };
    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "opportunityID":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              quationFieldDataState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              quationFieldDataState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "preferredBy":
          {
            const lengthRegex = new RegExp(".*");
            if (lengthRegex.test(event?.label) === true) {
              quationFieldDataState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              quationFieldDataState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "bussinesPartner":
          const fileroption = event?.label.toLowerCase();
          quationFieldDataState["billingAddress"] = "";
          quationFieldDataState["billingAddressStatus"] = "unchecked";
          quationFieldDataState["shippingAddress"] = "";
          quationFieldDataState["shippingAddressStatus"] = "unchecked";
          quationFieldDataState["customer"] = "";
          quationFieldDataState["customerStatus"] = "unchecked";
          quationFieldDataState["contactPerson"] = "";
          quationFieldDataState["contactPersonStatus"] = "unchecked";
          setContactDropDown([]);
          if (fileroption == "customer") {
            setCustomerOption(customerData);
          } else if (fileroption == "prospect") {
            setCustomerOption(leadData);
          } else {
            quationFieldDataState["billingAddress"] = "";
            quationFieldDataState["billingAddressStatus"] = "unchecked";
            quationFieldDataState["shippingAddress"] = "";
            quationFieldDataState["shippingAddressStatus"] = "unchecked";
            quationFieldDataState["customer"] = "";
            quationFieldDataState["customerStatus"] = "unchecked";
            quationFieldDataState["contactPerson"] = "";
            quationFieldDataState["contactPersonStatus"] = "unchecked";
            setCustomerOption([]);
            setContactDropDown([]);
          }
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              quationFieldDataState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              quationFieldDataState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "customer":
          const status = () => {
            return event?.label === undefined;
          };

          const newstatus = status();
          if (!newstatus) {
            const singledata = customerOption.filter(
              (v, i) => v?.id == event?.value
            );

            const data = singledata[0];

            const dataoption = [
              {
                value: data?.address1Line1 || data?.addressLine1,
                label: data?.address1Line1 || data?.addressLine1,
              },

              {
                value: data?.address2Line1,
                label: data?.address2Line1,
              },
            ];
            // request(BASEURL, getContactdetailByUser, {
            //   id: currentUser?.id,
            // }).then(
            //   async (res) =>
            //     await res?.getContactdetailByUser?.filter((v, i) => {
            //       if (v.organizationId == event?.value) {
            //         quationFieldDataState["contactPerson"] = v.firstName;

            //         quationFieldDataState["contactPersonStatus"] = "success";
            //       }
            //     })
            // );

            setSingleCustomerData(dataoption);
          } else {
            setSingleCustomerData([]);
            quationFieldDataState["billingAddress"] = "";
            quationFieldDataState["billingAddressStatus"] = "unchecked";
            quationFieldDataState["shippingAddress"] = "";
            quationFieldDataState["shippingAddressStatus"] = "unchecked";
            quationFieldDataState["contactPerson"] = "";
            quationFieldDataState["contactPersonStatus"] = "unchecked";
          }

          {
            const lengthRegex = new RegExp("^.*");
            if (lengthRegex.test(event?.label) === true) {
              quationFieldDataState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              request(
                BASEURL,
                isUser.toLowerCase() == "manager"
                  ? getContactdetailByMaster
                  : isUser.toLowerCase() == "employee"
                    ? getContactdetailByUser
                    : isUser.toLowerCase() == "superuser"
                      ? allContact
                      : "Data Not Found",
                { id: currentUser?.id }
              ).then((res) => {
                const response =
                  isUser.toLowerCase() == "manager"
                    ? res.getContactdetailByMaster
                    : isUser.toLowerCase() == "employee"
                      ? res.getContactdetailByUser
                      : isUser.toLowerCase() == "superuser"
                        ? res.allContact
                        : [];

                const cus = response.filter((val, ind) => {
                  if (
                    // val.organizationType.toLowerCase() ==
                    //   appointmentWithName.toLowerCase() &&
                    // val.organizationName.toLowerCase() ==
                    //   event?.label.toLowerCase()
                    val.organizationId == event?.value
                  ) {
                    return val;
                  } else {
                    quationFieldDataState["contactPerson"] = "";

                    quationFieldDataState["contactPersonStatus"] = "unchecked";
                  }
                });

                setContactDropDown(cus);
              });
            } else {
              quationFieldDataState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "shippingAddress":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              quationFieldDataState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              quationFieldDataState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "billingAddress":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              quationFieldDataState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              quationFieldDataState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactPerson":
          {
            const lengthRegex = new RegExp("^.*");

            if (lengthRegex.test(event?.label) === true) {
              quationFieldDataState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              quationFieldDataState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "accountingManager": {
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(event?.label) === true) {
            quationFieldDataState[selectEvent.name + "Status"] =
              event?.label === undefined ? "unchecked" : "success";
          } else {
            quationFieldDataState[selectEvent.name + "Status"] =
              selectEvent.value === "" ? "unchecked" : "error";
          }
        }
      }
      quationFieldDataState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "firstName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,20})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              quationFieldDataState[event.target.name + "Status"] = "success";
            } else {
              quationFieldDataState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "dueDate":
          {
            const selectedDate = new Date(event.target.value);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            if (selectedDate > currentDate) {
              quationFieldDataState[event.target.name + "Status"] = "success";
            } else {
              quationFieldDataState[event.target.name + "Status"] = "error";
            }
          }
          break;

        case "terms":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{2,250}$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              quationFieldDataState[event.target.name + "Status"] = "success";
            } else {
              quationFieldDataState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        // case "otherCharges":
        //   {
        //     const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,25})$");
        //     if (alphaNLenghthRegex.test(event.target.value?.trim())) {
        //       quationFieldDataState[event.target.name + "Status"] = "success";
        //     } else {
        //       quationFieldDataState[event.target.name + "Status"] =
        //         event.target.value === "" ? "unchecked" : "error";
        //     }
        //   }
          break;
        case "additionalInfo":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,250})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              quationFieldDataState[event.target.name + "Status"] = "success";
            } else {
              quationFieldDataState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "discount":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9 ]{1,2})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              quationFieldDataState[event.target.name + "Status"] = "success";
              let discountValue =
                ((quationFieldDataState["amountAndTax"] || 0) +
                  (quationFieldDataState["otherChargesAmount"] || 0)) *
                (event.target.value / 100);

              quationFieldDataState["discountAmount"] = discountValue;
              quationFieldDataState["discountAmountStatus"] = "success";
              let totalamount =
                quationFieldDataState["amountAndTax"] ||
                0 + quationFieldDataState["otherChargesAmount"] ||
                0 - discountValue ||
                0;

              quationFieldDataState["totalAmount"] = totalamount;
              quationFieldDataState["totalAmountStatus"] = "success";
            } else {
              quationFieldDataState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";

              quationFieldDataState["totalAmountStatus"] = "unchecked";
              quationFieldDataState["discountAmount"] = "";
              quationFieldDataState["discountAmountStatus"] = "unchecked";
            }
          }
          break;
        case "otherCharges":
          {
            const alphaNLenghthRegex = new RegExp("^.{1,100}$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              quationFieldDataState[event.target.name + "Status"] = "success";
              if (!quationFieldDataState.otherChargesAmount) {
                quationFieldDataState["otherChargesAmountStatus"] = "error";
              }
            } else {
              quationFieldDataState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "otherChargesAmount":
          {
            const alphaNLenghthRegex = new RegExp("^[0-9]{1,5}$");
            let value = event.target.value.trim();
            let numericValue = Number(value);
        
            quationFieldDataState[event.target.name] = numericValue === "" ? "unchecked" : numericValue.toString();

            if(value==="")
            {
              quationFieldDataState[event.target.name + "Status"] = "unchecked";
            }
            else{
            quationFieldDataState[event.target.name + "Status"] = 
              numericValue > 0 && alphaNLenghthRegex.test(value) ? "success" : "unchecked";
            }
            if (event.target.name === "otherChargesAmount") {
              quationFieldDataState["otherChargesAmountStatus"] =
                value === "" ? "unchecked" : numericValue > 0 && alphaNLenghthRegex.test(value) ? "success" : "error";
            }
            
          }
          break;
      }
      if (changeAllowed) {
        quationFieldDataState[event.target.name] = event.target.value;
      }
    }
    setQuationFieldData(quationFieldDataState);
  };

  const handleProductDataChange = (event, index, name) => {
    const temp = [...quationProductField];

    if (name === "tax") {
      if (event) {
        temp[index] = {
          ...temp[index],
          [name]: event,
          taxStatus: "success",
          taxAmount: (
            (parseFloat(quationProductField[index].totalproductamount) *
              event?.value) /
            100
          ).toFixed(2),
          taxAmountStatus: "success",
        };
      } else {
        temp[index] = {
          ...temp[index],
          [name]: event,
          taxStatus: "unchecked",
          taxAmount: 0,
          taxAmountStatus: "unchecked",
        };
      }
    } else if (name !== "productName") {
      if (event?.target?.value) {
        temp[index] = {
          ...temp[index],
          [name]: event.target.value,
          [name + "Status"]: "success",
        };
      } else {
        temp[index] = {
          ...temp[index],
          [name]: event.target.value,
          [name + "Status"]: "unchecked",
        };
      }
    } else {
      if (event) {
        temp[index] = {
          ...temp[index],
          [name]: event,
          productNameStatus: "success",
          quantity: "",
          quantityStatus: "unchecked",
          amount: "",
          amountStatus: "unchecked",
          totalproductamount: "",
          totalproductamountStatus: "unchecked",
          tax: "",
          taxStatus: "unchecked",
          taxAmount: "",
          taxAmountStatus: "unchecked",
          margin: "",
          marginStatus: "unchecked",
          marginAmount: "",
          marginAmountStatus: "unchecked",
        };

        const id = event?.value;

        productData.forEach((v) => {

          if (v?.id == id) {
            temp[index] = {
              ...temp[index],
              HSN: v?.HSNNumber,
              HSNStatus: "success",
              SKU: v?.SKU,
              SKUStatus: "success",
              rate: v?.productCost,
              rateStatus: "success",
            };
          }
        });
      } else {
        temp[index] = {
          ...temp[index],
          [name]: event,
          productNameStatus: "unchecked",
          HSN: "",
          HSNStatus: "unchecked",
          SKU: "",
          SKUStatus: "unchecked",
          rate: "",
          rateStatus: "unchecked",
          comments: "",
          commentsStatus: "unchecked",
          quantity: "",
          quantityStatus: "unchecked",
          margin: "",
          marginStatus: "unchecked",
          tax: "",
          taxStatus: "unchecked",
          amount: "",
          amountStatus: "unchecked",
          marginAmount: "",
          marginAmountStatus: "unchecked",
          taxAmount: "",
          taxAmountStatus: "unchecked",
          totalproductamount: "",
          totalproductamountStatus: "unchecked",
        };
      }
    }

    if (name === "quantity") {
      const alphaNLenghthRegex = new RegExp("^([0-9 ]{1,4})$");
      if (alphaNLenghthRegex.test(event.target.value?.trim())) {
        temp[index] = {
          ...temp[index],
          quantityStatus: "success",
          amount: (
            event.target.value * quationProductField[index].rate
          ).toFixed(2),
          amountStatus: "success",
        };
      } else {
        temp[index] = {
          ...temp[index],
          quantityStatus: event.target.value === "" ? "unchecked" : "error",
          amount: 0,
          amountStatus: "unchecked",
        };
      }
    } else if (name === "comments") {
      const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,50})$");
      if (alphaNLenghthRegex.test(event.target.value?.trim())) {
        temp[index] = {
          ...temp[index],
          commentsStatus: "success",
        };
      } else {
        temp[index] = {
          ...temp[index],
          commentsStatus: event.target.value === "" ? "unchecked" : "error",
        };
      }
    } else if (name === "margin") {
      const alphaNLenghthRegex = new RegExp("^([0-9]{1,2}(\\.[0-9]{1,2})?)$");
      if (alphaNLenghthRegex.test(event.target.value?.trim())) {
        const sum = (
          (parseFloat(quationProductField[index].amount) * event.target.value) /
          100
        ).toFixed(2);

        temp[index] = {
          ...temp[index],
          marginStatus: "success",
          subTotal: Number(quationFieldData.totalproductamount) - Number(quationFieldData.discountAmount),
          marginAmount: (
            (parseFloat(quationProductField[index].amount) *
              event.target.value) /
            100
          ).toFixed(2),
          marginAmountStatus: "success",
          totalproductamount: (
            Number(sum) + Number(quationProductField[index].amount)
          ).toFixed(2),
          totalproductamountStatus: "success",
        };
      } else {
        temp[index] = {
          ...temp[index],
          marginStatus: event.target.value === "" ? "unchecked" : "error",
          marginAmount: 0,
          marginAmountStatus: "unchecked",
          totalproductamount: 0,
          totalproductamountStatus: "unchecked",
        };
      }
    } else if (name === "marginAmount") {
      const alphaNLenghthRegex = new RegExp("^[0-9]{1,8}$");
      if (alphaNLenghthRegex.test(event.target.value?.trim())) {
        temp[index] = {
          ...temp[index],
          marginAmountStatus: "success",
          margin: (
            (Number(event.target.value) * 100) /
            parseFloat(quationProductField[index].amount)
          ).toFixed(2),
          totalproductamount:
            Number(event.target.value) +
            parseFloat(quationProductField[index].amount),
        };
      } else {
        temp[index] = {
          ...temp[index],
          marginAmountStatus: event.target.value === "" ? "unchecked" : "error",
        };
      }
    }

    setQuationProductField(temp);
  };


 const handleterms = (value) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = value;

  const lines = Array.from(tempDiv.querySelectorAll("p"));
  const nonEmptyLines = lines.filter(line => line.textContent.trim() !== "");

  if (nonEmptyLines.length > 10) {
    setTermsError(true);
    const trimmedHtml = nonEmptyLines
      .slice(0, 10)
      .map(line => `<p>${line.innerHTML}</p>`)
      .join("");

    setQuationFieldData(prev => ({
      ...prev,
      terms: trimmedHtml,
      termsStatus: "success",
    }));
    return;
  }
  else{
    setTermsError(false);
  }

  setQuationFieldData(prev => ({
    ...prev,
    terms: value,
    termsStatus: "success",
  }));
};


  const handleaddtional = (e) => {
    setQuationFieldData({
      ...quationFieldData,
      additionalInfo: e,
      additionalInfoStatus: "success"
    });
  };

  const handleFeature = (e) => {
    setQuationFieldData({
      ...quationFieldData,
      features: e,
    });
  };
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if(quationFieldData.otherChargesAmount !== '')
     
      {
        if (
          quationFieldData.accountingManager&&
          quationFieldData.customer &&
          quationFieldData.contactPerson&&
          quationFieldData.quoteDate&&
          quationFieldData.dueDate&&
          quationFieldData.terms&&
          quationFieldData.totalAmount&&
          quationFieldData.otherCharges
          // && quationFieldData.featureStatus === "success"
        ) {
          allowSubmit = true;
        }
      }
    else if(quationFieldData.otherChargesAmount == "" )
      {
        if(
        quationFieldData.accountingManager&&
        quationFieldData.customer &&
        quationFieldData.contactPerson &&
        quationFieldData.quoteDate&&
        quationFieldData.dueDate&&
        quationFieldData.terms &&
        quationFieldData.totalAmount
        )
        {
          allowSubmit = true;
        }
    }
    else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  useEffect(() => {
    if (!quationProductField) return;

    const productAmount = quationProductField.reduce(
      (acc, cur) => acc + Number(cur?.amount || 0),
      0
    );

    const marginAmount = quationProductField.reduce(
      (acc, cur) => acc + Number(cur?.marginAmount || 0),
      0
    );

    const SumofTaxAmount = quationProductField.reduce(
      (acc, cur) => acc + Number(cur?.taxAmount || 0),
      0
    );

    const total = SumofTaxAmount + productAmount + marginAmount;

    const newFieldData = { ...quationFieldData };

    if (productAmount || marginAmount) {
      const sum = productAmount + marginAmount;
      newFieldData.subTotal = Math.round(sum).toFixed(2);
      newFieldData.subTotalStatus = "success";
    } else {
      newFieldData.subTotal = 0;
      newFieldData.subTotalStatus = "unchecked";
    }

    if (SumofTaxAmount) {
      newFieldData.totalTax = Math.round(SumofTaxAmount).toFixed(2);
      newFieldData.totalTaxStatus = "success";
    } else {
      newFieldData.totalTax = 0;
      newFieldData.totalTaxStatus = "unchecked";
    }

    if (total) {
      newFieldData.amountAndTax = Math.round(total).toFixed(2);
      newFieldData.amountAndTaxStatus = "success";
      newFieldData.totalAmount = Math.round(total).toFixed(2);
      newFieldData.totalAmountStatus = "success";
    } else {
      newFieldData.amountAndTax = 0;
      newFieldData.amountAndTaxStatus = "unchecked";
    }

    setQuationFieldData(newFieldData);
  }, [JSON.stringify(quationProductField)]);

  const handleCancelQuationData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/Quotation");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleAddQuationData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        const values = {
          user: currentUser?.id,
          opportunity: quationFieldData.opportunityID?.value || "",
          customer: quationFieldData.customer?.value,
          billingAddress: quationFieldData.billingAddress?.label,
          shippingAddress: quationFieldData.shippingAddress?.label || "",
          contactPerson: quationFieldData.contactPerson?.label,
          businessPartner: quationFieldData.bussinesPartner?.label,
          quoteDate: quationFieldData.quoteDate,
          dueDate: quationFieldData.dueDate,
          accountingManager: quationFieldData.accountingManager?.value,
          termsAndConditions: quationFieldData.terms,
          additionalInformations: quationFieldData.additionalInfo,
          features: quationFieldData.features,
          subTotal: quationFieldData.subTotal || 0,
          totalTaxAmount: quationFieldData.totalTax || 0,
          amountAndTax: quationFieldData.amountAndTax || 0,
          otherCharges: quationFieldData.otherChargesAmount || 0,
          otherChargesDescription: quationFieldData.otherCharges,
          discount: quationFieldData.discountAmount || 0,
          discountPercentage: quationFieldData.discount || 0,
          totalAmount: quationFieldData.totalAmount || 0,
          preferredBy: quationFieldData.preferredBy?.value || rawPk,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const productvalues = quationProductField;

        setCirleLoading(true);

        const { errormessage, status } = await addQuationFieldService(
          values,
          productvalues,
          currentUser?.id
        );

        setCirleLoading(false);
        if (status) {
          setSuccessStatus(true);
          setSucessTitle("Quotation Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/quotation");
          }, 1000);
        } else if (!status) {
          setErrorStatus(true);
          setErrormessage(errormessage);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleEditQuationData = async () => {
    const productvalues = quationProductField;
      const data = await productvalues.map((val) => ({
        id: val.id,
        quotation: id1,
        productName: val.productName?.value,
        SKU: String(val.SKU),
        HSNNumber: val.HSN,
        comments: val.description,
        quantity: val.quantity.toString(), // Ensure quantity is a number
        rate: val.rate.toString(), // Ensure rate is a number
        tax: val.tax?.value?.toString(), // Ensure tax is a number
        taxAmount: Math.round(val.taxAmount).toString(),
        margin: val.margin.toString(), // Ensure margin is a number
        marginValue: Math.round(val.marginAmount).toString(),
        amount: Math.round(val.amount).toString(),
        productDiscount: Math.round(val.discountAmount).toString(),
        productDiscountPercentage: val.discount.toString(),
      }));
      if (params.pathname == "/quotation/view-quotation") {
        setEditstatustrue(true);
      }
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to submit your details.",
        showCancel: true,
        showConfirm: true,

        onConfirm: async () => {
          const values = {
            id: id1,
            opportunity: quationFieldData.opportunityID?.value || null,
            customer: quationFieldData.customer?.value.toString(),
            billingAddress: quationFieldData.billingAddress?.label,
            shippingAddress: quationFieldData.shippingAddress?.label,
            businessPartner: quationFieldData.bussinesPartner?.label,
            contactPerson: quationFieldData.contactPerson?.label,
            quoteDate: quationFieldData.quoteDate,
            dueDate: quationFieldData.dueDate,
            accountingManager: quationFieldData.accountingManager?.value,
            termsAndConditions: quationFieldData.terms,
            additionalInformations: quationFieldData.additionalInfo,
            features: quationFieldData.features,
            subTotal: parseInt(quationFieldData.subTotal).toString(),
            totalTaxAmount: parseInt(quationFieldData.totalTax).toString(),
            amountAndTax: parseInt(quationFieldData.amountAndTax).toString,
            otherCharges: parseInt(quationFieldData.otherChargesAmount || 0).toString(),
            otherChargesDescription: quationFieldData.otherCharges,
            discount: parseInt(quationFieldData.discountAmount).toString,
            discountPercentage: parseInt(quationFieldData.discount).toString,
            totalAmount: parseInt(quationFieldData.totalAmount).toString(),
            preferredBy: quationFieldData.preferredBy?.value || rawPk,
            quotationproduct: data,
          };
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setCirleLoading(true);

          const status = await updateQuationService(values);

          setCirleLoading(false);
          if (status) {
            setSuccessStatus(true);
            setSucessTitle("Quotation Updated");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/quotation");
            }, 2000);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };
  const handledelteQuationData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delte your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        const status = await delteQuationService(id1);

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });

        status ? navigate("/quotation") : alert("err");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };



  useEffect(() => {
    if (idValue) {
      const customerOrLeadNameValue = () => {
        if (idValue?.opportunityFrom == "Customer") {
          const filter = customerData.filter((val, i) => {
            if (val?.id == idValue?.customerOrLeadName) {
              return val;
            }
          });

          return filter;
        } else if (idValue?.opportunityFrom == "Prospect") {
          const filter = leadData.filter((val, i) => {
            return val;
          });

          return filter;
        }
      };
      const data = customerOrLeadNameValue();

      // const value = data[0];

      if (data) {
        const dataoption = [
          {
            value: data[0]?.address1Line1,
            label: data[0]?.address1Line1,
          },
          {
            value: data[0]?.address1Line2,
            label: data[0]?.address1Line2,
          },
          {
            value: data[0]?.address2Line1,
            label: data[0]?.address2Line1,
          },
          {
            value: data[0]?.address2Line2,
            label: data[0]?.address2Line2,
          },
        ];
        setSingleCustomerData(dataoption);
      }
      setDisbledStatus(false);
      setQuationFieldData({
        ...quationFieldData,
        opportunityID: idValue?.opportunityID,
        bussinesPartner: idValue?.opportunityFrom,
        contactPerson: idValue?.contactPerson,
        customer: idValue?.customer,

        contactPersonStatus: "success",
        opportunityIDStatus: "success",
        customerStatus: "success",
        bussinesPartnerStatus: "success",
      });
    }
  }, [idValue]);



  const handleDiscountChange = (e,i) => {
    const alphaNLenghthRegex = new RegExp("^([0-9 ]{1,2})$");
    let value = e?.target.value;

    const newquotationproductField = [...quationProductField];
    const newquationFieldData ={...quationFieldData};
    newquotationproductField[i].discount = value;

   


    newquotationproductField[i].discountAmount =newquotationproductField[i].totalproductamount*Number(value)/100;
    
    setQuationProductField(newquotationproductField);
    
    let discountAmount = 0;
    let totalAmount = Number(quationFieldData.amountAndTax) + Number(quationFieldData.otherChargesAmount);
  
  };

  useEffect(() => {

    const newquotationproductField = [...quationProductField];
    const newquationFieldData = { ...quationFieldData };
    const discountTotal = newquotationproductField.reduce((total, product) => {
      
      return total + Number(product.discountAmount);
    }, 0); 

    const totalAmount = newquotationproductField.reduce((total, product) => {
     return total + Number(product.totalproductamount); 
    }, 0); 

    const taxAmount = newquotationproductField.reduce((total, product) => {
     return total + Number(product.taxAmount); 
    }, 0); 

     newquationFieldData.discountAmount = discountTotal.toFixed(2);
     newquationFieldData.subTotal= totalAmount-discountTotal.toFixed(2);
     newquationFieldData.totalTax = taxAmount.toFixed(2);
     newquationFieldData.discountAmountStatus = "success";
     newquationFieldData.discountStatus = "success";
     setQuationFieldData(newquationFieldData);
     

    
  }, [quationProductField]);
  
useEffect(() => {
    const newquationFieldData = { ...quationFieldData };
    const totalAmount = Number(newquationFieldData.subTotal) + Number(newquationFieldData.totalTax);
    newquationFieldData.amountAndTax = totalAmount.toFixed(2);
    newquationFieldData.totalAmount = totalAmount + Number(newquationFieldData.otherChargesAmount);
    setQuationFieldData(newquationFieldData);
    
},[quationFieldData.subTotal,quationFieldData.totalTax,quationFieldData.otherChargesAmount]);

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h6" fontWeight="medium">
                        {location.pathname.includes("/edit-quotation")
                          ? "Edit Quotation Details"
                          : location.state && location.state.type === "view"
                            ? "Quotation Details"
                            : "Add Quotation Details"}
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                           <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                           <MaterialTypography
                                           sx={{color:'#460058',fontFamily:'Aptos'}}
                                             component="label"
                                             variant="body2"
                                             fontWeight="700"
                                           >
                                             Quotation Information
                                           </MaterialTypography>
                                         </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Opportunity ID
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="opportunityID"
                  size="small"
                  value={quationFieldData.opportunityID}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={opportunityIdOptions.map((value) => {
                    return {
                      value: value.id,
                      label: value.oppid,
                    };
                  })}
                  error={
                    quationFieldData.opportunityIDStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.opportunityIDStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={editStatustrue || ConvertToQuoteStatus}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Prepared By
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="preferredBy"
                  size="small"
                  value={quationFieldData.preferredBy}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={allEmployee?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.username,
                    };
                  })}
                  error={
                    quationFieldData.preferredByStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.preferredByStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={editStatustrue}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Business Partner <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="bussinesPartner"
                  size="small"
                  value={quationFieldData.bussinesPartner}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={bussinessPartnerOptions?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  error={
                    quationFieldData.bussinesPartnerStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.bussinesPartnerStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={editStatustrue || ConvertToQuoteStatus}
                />
              </Grid>
              
              <Grid size={{ xs: 5, sm: 3 }}>
                
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Organization Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customer"
                  size="small"
                  value={quationFieldData.customer}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={customerOption.map((value) => {
                    return {
                      value: value.id || value?.id,
                      label: value.legalName || value?.companyName,
                    };
                  })}
                  error={
                    quationFieldData.customerStatus === "error" ? true : false
                  }
                  success={
                    quationFieldData.customerStatus === "success" ? true : false
                  }
                  isDisabled={editStatustrue || ConvertToQuoteStatus}
                  
                />
              </Grid>
             
              {/* <Grid size={{ xs: 5, sm: 3 }}> */}
              <div style={{width: "49.2%"}}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Billing Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="billingAddress"
                  size="small"
                  value={quationFieldData.billingAddress}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={singleCustomerData?.map((v, i) => {
                    return {
                      value: v.value,
                      label: v.label?? "",
                    };
                  })}
                  error={
                    quationFieldData.billingAddressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.billingAddressStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={editStatustrue}
                 
                />
                {quationFieldData.billingAddressStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Select a Proper Address
                    </FormHelperText>
                  </FormControl>
                )}
              {/* </Grid> */}
              </div>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Contact Person <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {/* <MaterialInput
                  name="contactPerson"
                  type="text"
                  placeholder="eg. Tamilpriyan"
                  value={quationFieldData.contactPerson}
                  onChange={handleQuationDataChange}
                  error={
                    quationFieldData.contactPersonStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.contactPersonStatus === "success"
                      ? true
                      : false
                  }
                  disabled={true}
                /> */}
                <MaterialSelect
                  name="contactPerson"
                  size="small"
                  value={quationFieldData.contactPerson}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={contactDropDown?.map((v, i) => {
                    return {
                      value: v.id,
                      label: v.firstName,
                    };
                  })}
                  error={
                    quationFieldData.contactPersonStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.contactPersonStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={editStatustrue || ConvertToQuoteStatus}
                />
                {quationFieldData.contactPersonStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      First Name should be maximum 20 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Quote Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="quoteDate"
                  type="date"
                  size="small"
                  placeholder="eg. 01-01-2024"
                  value={quationFieldData.quoteDate}
                  onChange={handleQuationDataChange}
                  error={
                    quationFieldData.quoteDateStatus === "error" ? true : false
                  }
                  success={
                    quationFieldData.quoteDateStatus === "success"
                      ? true
                      : false
                  }
                  disabled={true}
                  // isDisabled={editStatustrue}
                />
                {quationFieldData.quoteDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {/* <Grid size={{ xs: 5, sm: 3 }}> */}
              <div style={{width: "49.2%"}}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Shipping Address{" "}
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="shippingAddress"
                  size="small"
                  value={quationFieldData.shippingAddress}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={singleCustomerData?.map((v, i) => {
                    return {
                      value: v.value,
                      label: v.label,
                    };
                  })}
                  error={
                    quationFieldData.shippingAddressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.shippingAddressStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={editStatustrue}
                />
                {quationFieldData.shippingAddressStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Select a Proper Address
                    </FormHelperText>
                  </FormControl>
                )}
              {/* </Grid> */}
              </div>
              
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Due Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="dueDate"
                  type="date"
                  size="small"
                  placeholder="eg. 01-01-2024"
                  value={quationFieldData.dueDate}
                  onChange={handleQuationDataChange}
                  error={
                    quationFieldData.dueDateStatus === "error" ? true : false
                  }
                  success={
                    quationFieldData.dueDateStatus === "success" ? true : false
                  }
                  inputProps={{
                    min: today,
                  }}
                  disabled={editStatustrue}
                />
                {quationFieldData.dueDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                     fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Report Manager <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="accountingManager"
                  size="small"
                  value={quationFieldData.accountingManager}
                  defaultValue={{ label: "Please select" }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleQuationDataChange} //selectedValue, event
                  options={managerDataOption.map((value) => {
                    return {
                      value: value.id,
                      label: value.username,
                    };
                  })}
                  error={
                    quationFieldData.accountingManagerStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    quationFieldData.accountingManagerStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={editStatustrue}
                />
              </Grid>
            </Grid>
          </MaterialBox>
          <Divider />
             <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                    <BsFillPersonBadgeFill style={{ fontSize: 20, color: '#460058' }} />
                    <MaterialTypography
                      sx={{ color: '#460058', fontFamily: 'Aptos' }}
                      component="label"
                      variant="body2"
                      fontWeight="700"
                    >
                      Product Details
                    </MaterialTypography>
                  </Stack>
          <Box mt={2}> 
            {quationProductField.map((v, i) => {
              return (
                <div key={i} className="mainproduct-box">
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontSize="14px"
                      fontFamily="Aptos"
                    >
                      Product Name<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ width: "95%" }}>
                      <MaterialSelect
                        name="productName"
                        size="small"
                        value={v.productName}
                        defaultValue={{ label: "Please select" }}
                        customStyles={{ optionPadding: 20 }}
                        onChange={(e) =>
                          handleProductDataChange(e, i, "productName")
                        } //selectedValue, event
                        options={productData?.map((value) => {
                          return {
                            value: value?.id,
                            label: value?.productName,
                          };
                        })}
                        error={
                          quationProductField[i].productNameStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          quationProductField[i].productNameStatus === "success"
                            ? true
                            : false
                        }
                        isDisabled={editStatustrue}
                      />{" "}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "5%",
                        marginLeft: "20px",
                      }}
                    >
                      <button
                        onClick={handleaddProductRow}
                        className="quation-add"
                        disabled={editStatustrue }
                         style={{
                          cursor: editStatustrue ? "not-allowed" : "pointer",
                        }}
                        // disabled={v?.productName?.label ? false : true}
                        // style={{
                        //   cursor: v?.productName?.label
                        //     ? "pointer"
                        //     : "not-allowed",
                        // }}
                      >
                        +
                      </button>
                      <div style={{alignContent: "center", justifyContent: "center"}}>
                      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                        <Alert
                          onClose={handleClose}
                          severity="success"
                          variant="filled"
                          sx={{ width: '100%' }}
                        >
                          Product Created Below
                        </Alert>
                      </Snackbar>
                      </div>
                    </div>
                  </div>

                  {i != 0 && (
                    <button
                      onClick={() => handledelteProductRow(i)}
                      className="quation-minus"
                      disabled={editStatustrue }
                      style={{
                          cursor: editStatustrue ? "not-allowed" : "pointer",
                      }}
                    >
                      -
                    </button>
                  )}
                  <Divider />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div className="productdeatils-insidebox">
                      <Stack
                        direction="row"
                        spacing={1}
                        className="inside-head"
                      >
                        {/* <BsFillPersonVcardFill style={{ fontSize: 18 }} /> */}
                        <MaterialTypography
                          component="label"
                          variant="body2"
                          fontWeight="normal"
                          fontSize="17px"
                      fontFamily="Aptos"
                        >
                          Description
                        </MaterialTypography>
                      </Stack>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              HSN
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="HSN"
                            placeholder="Hsn"
                            value={v.HSN}
                            size="small"
                            // onChange={handleleadandProspectData}
                            error={v.HSNStatus === "error" ? true : false}
                            success={v.HSNStatus === "success" ? true : false}
                            disabled={true}
                          />
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              SKU
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="SKU"
                            placeholder="Sku"
                            value={v.SKU}
                            size="small"
                            // onChange={handleleadandProspectData}
                            error={v.SKUStatus === "error" ? true : false}
                            success={v.SKUStatus === "success" ? true : false}
                            disabled={true}
                          />
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Comments
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="comments"
                            placeholder="Enter comments"
                            size="small"
                            value={v.comments}
                            onChange={(e) =>
                              handleProductDataChange(e, i, "comments")
                            } //selectedValue, event
                            error={v.commentsStatus === "error" ? true : false}
                            success={
                              v.commentsStatus === "success" ? true : false
                            }
                            disabled={editStatustrue}
                          />
                          {v.commentsStatus === "error" && (
                            <FormControl error>
                              <FormHelperText>
                                maximum 50 characters
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Grid>
                      </div>
                    </div>
                    <div className="productdeatils-insidebox">
                      <Stack
                        direction="row"
                        spacing={1}
                        className="inside-head"
                      >
                        {/* <BsFillPersonVcardFill style={{ fontSize: 18 }} /> */}
                        <MaterialTypography
                          component="label"
                          variant="body2"
                          fontWeight="normal"
                          fontSize="17px"
                          fontFamily="Aptos"
                        >
                          Quantity / Unit / Rate
                        </MaterialTypography>
                      </Stack>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Quantity <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="quantity"
                            placeholder="Enter quantity"  
                            size="small"    
                            value={v.quantity}
                            onChange={(e) =>
                              handleProductDataChange(e, i, "quantity")
                            } //selectedValue, event
                            error={v.quantityStatus === "error" ? true : false}
                            success={
                              v.quantityStatus === "success" ? true : false
                            }
                            isDisabled={editStatustrue}
                            disabled={!quationProductField[i]?.productName}
                          />
                          {v.quantityStatus === "error" && (
                            <FormControl error>
                              <FormHelperText>
                                Accept only number max length 4
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Rate <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="rate"
                            size="small"
                            placeholder="Enter Rate"
                            value={v.rate}
                            // onChange={handleleadandProspectData}
                            error={v.rateStatus === "error" ? true : false}
                            success={v.rateStatus === "success" ? true : false}
                            disabled={true}
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <CurrencyRupeeIcon />
                                </Icon>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Amount <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="amount"
                            placeholder="Amount"
                            size="small"
                            value={v.amount}
                            // onChange={handleleadandProspectData}
                            error={v.amountStatus === "error" ? true : false}
                            success={
                              v.amountStatus === "success" ? true : false
                            }
                            disabled={true}
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <CurrencyRupeeIcon />
                                </Icon>
                              ),
                            }}
                          />
                        </Grid>
                      </div>
                    </div>
                    <div className="productdeatils-insidebox">
                      <Stack
                        direction="row"
                        spacing={1}
                        className="inside-head"
                      >
                        {/* <BsFillPersonVcardFill style={{ fontSize: 18 }} /> */}
                        <MaterialTypography
                           component="label"
                          variant="body2"
                          fontWeight="normal"
                          fontSize="17px"
                          fontFamily="Aptos"
                        >
                          Tax / Margin
                        </MaterialTypography>
                      </Stack>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Margin % <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="margin"
                            type="text"
                            size="small"
                            placeholder="Enter Margin "
                            value={v.margin}
                            onChange={(e) =>
                              handleProductDataChange(e, i, "margin")
                            }
                            error={v.marginStatus === "error" ? true : false}
                            success={
                              v.marginStatus === "success" ? true : false
                            }
                            isDisabled={editStatustrue}
                            disabled={!quationProductField[i]?.quantity}
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <PercentIcon />
                                </Icon>
                              ),
                            }}
                          />
                          {v.marginStatus === "error" && (
                            <FormControl error>
                              <FormHelperText>maximum 2 number</FormHelperText>
                            </FormControl>
                          )}
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Margin Amount{" "}
                              <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="marginAmount"
                            size="small"
                            placeholder="Margin Amount"
                            value={v.marginAmount}
                            onChange={(e) =>
                              handleProductDataChange(e, i, "marginAmount")
                            }
                            error={
                              v.marginAmountStatus === "error" ? true : false
                            }
                            success={
                              v.marginAmountStatus === "success" ? true : false
                            }
                            // disabled={true}
                            disabled={!quationProductField[i]?.margin}
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <CurrencyRupeeIcon />
                                </Icon>
                              ),
                            }}
                          
                          />
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Tax % <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialSelect
                            name="tax"
                            size="small"
                            value={v?.tax}
                            defaultValue={{ label: "Please Select Tax" }}
                            customStyles={{ optionPadding: 20 }}
                            onChange={(e) =>
                              handleProductDataChange(e, i, "tax")
                            } //selectedValue, event
                            options={taxOption?.map((value) => {
                              return {
                                value: value.id,
                                label: value.label,
                              };
                            })}
                            
                            isDisabled={!quationProductField[i]?.marginAmount}
                            error={v.taxStatus === "error" ? true : false}
                            success={v.taxStatus === "success" ? true : false}
                            
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <PercentIcon />
                                </Icon>
                              ),
                            }}
                          />{" "}
                        </Grid>
                      </div>
                    </div>
                    <div className="productdeatils-insidebox">
                      <Stack
                        direction="row"
                        spacing={1}
                        className="inside-head"
                      >
                        {/* <BsFillPersonVcardFill style={{ fontSize: 18 }} /> */}
                        <MaterialTypography
                           component="label"
                          variant="body2"
                          fontWeight="normal"
                          fontSize="17px"
                          fontFamily="Aptos"
                        >
                          Amount
                        </MaterialTypography>
                      </Stack>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                      <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Discount Percentage
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            size="small"
                            name="discount"
                            placeholder="Discount percentage"
                            value={quationProductField.discount}
                            onChange={(e)=>handleDiscountChange(e,i)}
                            error={
                              quationFieldData.discountStatus === "error"
                                ? true
                                : false
                            }
                            success={
                              quationFieldData.discountStatus === "success"
                                ? true
                                : false
                            }
                            // disabled={!quationProductField[i]?.tax}
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <PercentIcon />
                                </Icon>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Tax Amount <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="taxAmount"
                            size="small"
                            placeholder="Tax Amount "
                            value={v.taxAmount}
                            // onChange={handleleadandProspectData}
                            error={v.taxAmountStatus === "error" ? true : false}
                            success={
                              v.taxAmountStatus === "success" ? true : false
                            }
                            disabled={true}
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <CurrencyRupeeIcon />
                                </Icon>
                              ),
                            }}
                            
                          />
                        </Grid>
                        <Grid size={{ xs: 5, sm: 3 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontSize="14px"
                              fontFamily="Aptos"
                            >
                              Product Amount{" "}
                              <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="totalproductamount"
                            size="small"
                            value={v.totalproductamount}
                            placeholder="Product Amount"
                            onChange={(e) =>
                              handleProductDataChange(
                                e,
                                i,
                                "totalproductamount"
                              )
                            }
                            error={
                              v.totalproductamountStatus === "error"
                                ? true
                                : false
                            }
                            success={
                              v.totalproductamountStatus === "success"
                                ? true
                                : false
                            }
                            disabled={true}
                            icon={{
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <CurrencyRupeeIcon />
                                </Icon>
                              ),
                            }}
                          
                          />
                        </Grid>
                      </div>
                    </div>
                  </div>
                 
                </div>
              );
            })}

            <Divider />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                  paddingRight: "20px",
                }}
              >
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"                
                    fontSize="17px"
                    fontFamily="Aptos"
                  >
                    Terms and condition <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <div style={{ width: "100%" }}>
                  
                  <ReactQuill
                    value={quationFieldData?.terms}
                    onChange={(e) => handleterms(e)}
                    style={{ height: "250px", width: "100%" }}
                    readOnly={editStatustrue}
                  />
                  
                
                     
                </div>
                  <div style={{ marginTop: '50px' }}>
                  {termsError && (
                     <FormControl error>
                      <FormHelperText>
                        Line Limit Reached
                      </FormHelperText>
                    </FormControl>
                  )}
                  </div>
              </div>
             {/* Additional Features */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                  paddingLeft: "20px",
                }}
              >
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="17px"
                    fontFamily="Aptos"
                  >
                    Additional Informations{" "}
                  </MaterialTypography>
                </MaterialBox>
               
                <ReactQuill
                  value={quationFieldData?.additionalInfo}
                  onChange={(e) => handleaddtional(e)}
                  style={{ height: "250px", width: "100%" }}
                  readOnly={editStatustrue}
                />
                {quationFieldData.additionalInfoStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Additional Informations should be min 2 characters to
                      maximum 20 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </div>
            </div>
            <br></br>
            <div style={{ marginTop: '20px' }}>

              <MaterialTypography
                component="label"
                variant="caption"
                fontSize="17px"
                fontFamily="Aptos"
              >
                Features <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <ReactQuill
                value={quationFieldData?.features}
                onChange={(e) => handleFeature(e)}
                style={{ height: "300px", width: "100%" }}
                readOnly={editStatustrue}
              />
            </div>
            <br></br>
            <Divider />
            <br></br>
            <MaterialBox>
              <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                        fontSize="13px"
                    fontFamily="Aptos"
                    >
                      Discount Amount
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                  name="discountAmount"
                  size="small"
                    placeholder=" Discount Amount"
                    value={quationFieldData.discountAmount}
                      error={
                            quationFieldData.discountAmountStatus === "error"
                              ? true
                              : false
                          }
                          success={
                            quationFieldData.discountAmountStatus === "success"
                              ? true
                              : false
                          }
                    disabled={true}
                    icon={{
                      direction: "right",
                      component: (
                        <Icon color="action" fontSize="small">
                          <CurrencyRupeeIcon />
                        </Icon>
                      ),
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontSize="13px"
                      fontFamily="Aptos"
                    >
                      Sub total <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="subTotal"
                    size="small"
                    placeholder="Sub total"
                    value={quationFieldData.subTotal}
                    // onChange={handleleadandProspectData}
                    error={
                      quationFieldData.subTotalStatus === "error" ? true : false
                    }
                    success={
                      quationFieldData.subTotalStatus === "success"
                        ? true
                        : false
                    }
                    disabled={true}
                    icon={{
                      direction: "right",
                      component: (
                        <Icon color="action" fontSize="small">
                          <CurrencyRupeeIcon />
                        </Icon>
                      ),
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontSize="13px"
                      fontFamily="Aptos"
                    >
                      Total Tax<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="totalTax"
                    size="small"
                    placeholder="Total Tax"
                    value={quationFieldData.totalTax}
                    // onChange={handleleadandProspectData}
                    error={
                      quationFieldData.totalTaxStatus === "error" ? true : false
                    }
                    success={
                      quationFieldData.totalTaxStatus === "success"
                        ? true
                        : false
                    }
                    disabled={true}
                    
                  />
                </Grid>
                <Grid size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontSize="13px"
                      fontFamily="Aptos"
                    >
                      Amount & Tax <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="amountAndTax"
                    size="small"
                    placeholder="Amount and Tax"
                    value={quationFieldData.amountAndTax}
                    // onChange={handleleadandProspectData}
                    error={
                      quationFieldData.amountAndTaxStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      quationFieldData.amountAndTaxStatus === "success"
                        ? true
                        : false
                    }
                    disabled={true}
                   
                  />
                </Grid>
              </Grid>
            </MaterialBox>

            <MaterialBox>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  style={{
                    // border: "solid 1px grey",
                    // padding: "5px",
                    marginTop: "10px",
                  }}
                >
                  <span>
                   
                  
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontSize="13px"
                      fontFamily="Aptos"
                    >
                      Other Charges
                    </MaterialTypography>
                  </MaterialBox>
                  
                    <button
                      style={{marginLeft: "10px",borderRadius: "95px", width: "30px",height: "30px"}}
                      onClick={handleToggleOtherCharges}
                      disabled={showOtherCharges || editStatustrue}>
                        +
                    </button>
                    </span>
                     {showOtherCharges && (
                      <>
                      <div style={{ display: "flex", border: "solid 1px grey", padding: "5px", marginTop: "5px", borderRadius: "10px" }}>
                        <div style={{width: "240px"}}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontSize="13px"
                            fontFamily="Aptos"
                          >
                            Description<span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="otherCharges"
                          placeholder="Description"
                          size="small"
                          value={quationFieldData.otherCharges}
                          inputProps={{maxLength:25}}
                          onChange={handleQuationDataChange}
                          error={
                            quationFieldData.otherChargesStatus === "error"
                              ? true
                              : false
                          }
                          success={
                            quationFieldData.otherChargesStatus === "success"
                              ? true
                              : false
                          }
                          disabled={editStatustrue}
                        />
                        {quationFieldData.otherChargesStatus === "error" && (
                          <FormControl error>
                            <FormHelperText>
                              Description should be Maximum 25 characters
                            </FormHelperText>
                          </FormControl>
                        )}
                      </div>
  
                      <div style={{ width: "150px", marginLeft: "10px" }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                              fontSize="13px"
                              fontFamily="Aptos"
                          >
                            Amount<span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          name="otherChargesAmount"
                          type="number"
                          placeholder="Amount"
                          size="small"
                          value={quationFieldData.otherChargesAmount}
                          onChange={handleQuationDataChange}
                          error={
                            quationFieldData.otherChargesAmountStatus === "error"
                              ? true
                              : false
                          }
                          success={
                            quationFieldData.otherChargesAmountStatus ===
                              "success"
                              ? true
                              : false
                          }
                          disabled={editStatustrue}
                     
                        />
                        {quationFieldData.otherChargesAmountStatus === "error" && (
                        <FormHelperText error>Please enter correct amount.</FormHelperText>
                        )}
                      </div>
                      <button
                    style={{backgroundColor: "#f10000",borderRadius: "95px", width: "35px",height: "35px", marginTop: "35px", marginLeft: "5px"}}
                    onClick={handleToggleOtherCharges}
                    disabled={editStatustrue}>
                      <DeleteIcon></DeleteIcon>
                    </button>
                    </div>
                    
                    </>
                    )}
                    
                  
                
                </div>
               
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "end",
                    padding: "0px 10px",
                  }}
                >
                  <div>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontSize="13px"
                        fontFamily="Aptos"
                      >
                        Total Amount <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="totalAmount"
                      placeholder="Total Amount"
                      size="small"
                      value={
                        quationFieldData.totalAmount
                      }
                      error={
                        quationFieldData.totalAmountStatus === "error"
                          ? true
                          : false
                      }
                      success={
                        quationFieldData.totalAmountStatus === "success"
                          ? true
                          : false
                      }
                      disabled={true}
                    
                    />
                  </div>
                </div>
              </div>
            </MaterialBox>
          </Box>
        </CardContent>

        {location?.state?.type !== "view" && (
          <MaterialBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 4.5, }}
          >
            <>
              {" "}
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                size="small"
                onClick={handleCancelQuationData}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                size="small"
                disabled={!checkAllFields()}
                onClick={
                  editdisablebutton
                    ? handleAddQuationData
                    : handleEditQuationData
                }
              >
                {editdisablebutton ? "submit" : "update"}
              </MaterialButton>
            </>
          </MaterialBox>
        )}
      </Card>
    </DashboardLayout>
  );
};

export default QuationsForm;
